import Vue from 'vue'
import Router from 'vue-router'
import VModal from 'vue-js-modal'
import de from 'vee-validate/dist/locale/de'
import VeeValidate from 'vee-validate'


Vue.use(Router)
Vue.use(VModal, {dialog: true, dynamic: true,})
Vue.use(VeeValidate, {
    classes: true,
})
VeeValidate.Validator.localize('de', de);

VeeValidate.Validator.extend('minLength', {
    getMessage(field, [length]) {
        return `Mindestens ${length} auswählen`;
    },
    validate(value, [length]) {
        return value.length >= length;
    }
})

export default new Router({
    mode: 'abstract',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
        },
    ]
})
